import React from 'react';
import { Box, Button, Paper, Tooltip, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
	CIVIL_DATE_PRESETS,
	CIVIL_DATE_PRESET_LABELS,
	CivilDatePreset,
	formatDateRangeLabel,
	getDateRangeFromPreset,
} from 'features/common/helpers/datePresets';

interface PaymentsQuickDateBarProps {
	activePreset: CivilDatePreset | '';
	onPresetToggle: (preset: CivilDatePreset) => void;
}

const PRESET_BUTTON_SX = { minWidth: 'auto', px: 1.25, py: 0.35, fontSize: '0.8125rem', textTransform: 'none' };

const ACTIVE_FILTER_BADGE_SX = {
	position: 'absolute',
	top: -7,
	right: -7,
	fontSize: 13,
	bgcolor: 'background.paper',
	borderRadius: '50%',
	border: '1px solid',
	borderColor: 'primary.main',
	color: 'primary.main',
	p: '1px',
	pointerEvents: 'none',
	boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
	zIndex: 1,
};

export const PaymentsQuickDateBar = ({ activePreset, onPresetToggle }: PaymentsQuickDateBarProps): JSX.Element => (
	<Paper
		elevation={0}
		sx={{
			p: 1.5,
			mb: 2,
			borderRadius: 2,
			border: '1px solid rgba(0,0,0,0.08)',
			background: 'linear-gradient(180deg, #fafbff 0%, #ffffff 100%)',
		}}
	>
		<Box display="flex" alignItems="center" flexWrap="wrap" gap={0.75}>
			<Typography variant="caption" color="text.secondary" sx={{ minWidth: 88, fontWeight: 600 }}>
				Fecha de pago
			</Typography>
			{CIVIL_DATE_PRESETS.map((preset) => {
				const range = getDateRangeFromPreset(preset);
				const isActive = activePreset === preset;
				return (
					<Tooltip
						key={preset}
						title={
							isActive
								? `${formatDateRangeLabel(range.from, range.to)} — Clic para quitar`
								: formatDateRangeLabel(range.from, range.to)
						}
					>
						<Box component="span" sx={{ position: 'relative', display: 'inline-flex' }}>
							<Button
								size="small"
								variant={isActive ? 'contained' : 'outlined'}
								onClick={() => onPresetToggle(preset)}
								aria-pressed={isActive}
								sx={PRESET_BUTTON_SX}
							>
								{CIVIL_DATE_PRESET_LABELS[preset]}
							</Button>
							{isActive && <CloseIcon sx={ACTIVE_FILTER_BADGE_SX} />}
						</Box>
					</Tooltip>
				);
			})}
		</Box>
	</Paper>
);
